@if (fieldName) {
  <div>
    @if (fieldName && fieldName.invalid && (fieldName.dirty || fieldName.touched)) {
      <div class="{{newClass}}">
        @if (fieldName.errors?.['required'] && fieldName.errors?.['required'] != undefined) {
          <div>
            {{message.required | translate}}
          </div>
        }
        @if (fieldName.errors?.['minlength'] != '' && fieldName.errors?.['minlength'] != undefined) {
          <div>
            {{message.minlength | translate}}
          </div>
        }
        @if (fieldName.errors?.['maxlength'] != '' && fieldName.errors?.['maxlength'] != undefined) {
          <div>
            {{message.maxlength | translate}}
          </div>
        }
        @if (fieldName.errors?.['email']) {
          <div>
            {{message.email | translate}}
          </div>
        }
        @if (fieldName.errors?.['mustMatch']) {
          <div>
            {{message.mustMatch | translate}}
          </div>
        }
        @if (fieldName.errors?.['noHtmltag']) {
          <div>
            {{message.noHtmltag | translate}}
          </div>
        }
        @if (fieldName.errors?.['noSpace']) {
          <div>
            {{message.noSpace | translate}}
          </div>
        }
        @if (fieldName.errors?.['pattern']) {
          <div>
            {{message.pattern | translate}}
          </div>
        }
        @if (fieldName.errors?.['passwordComplexity']) {
          <div>
            {{message.passwordComplexity | translate}}
          </div>
        }
      </div>
    }
  </div>
}